export default "__VITE_ASSET__FKts1gSh__";